// The theme storageKey is interpolated verbatim into an inline <script> by next-themes
// (dangerouslySetInnerHTML, single-quoted). Every user-controlled segment that flows in
// (embedNamespace from ?embed=, themeBasis from the URL path) must therefore be limited
// to characters that cannot break out of the script/string literal context. Disallowed
// characters are replaced with "_" (inside the allowlist) to preserve key length/shape
// and avoid collapsing distinct inputs to the same sanitized output.
const UNSAFE_STORAGE_KEY_CHARS = /[^A-Za-z0-9_\-:.@+%]/g;

export function sanitizeThemeStorageKey(key: string): string {
  return key.replace(UNSAFE_STORAGE_KEY_CHARS, "_");
}
